import React, {FunctionComponent} from 'react';
import {Field} from 'react-final-form';
import {FieldValidator} from '../../commonOpenSite/validation/validator.interface';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./signupField.component.scss');

interface SignupFieldProps {
    errorToMessage: (error: any) => string;
    validate: FieldValidator<string>;
    name: string;
    tabIndex?: number;
    placeholder?: string;
    type?: string;
    icon?: string;
    id?: string;
    ariaLabel?: string;
    validateFields?: string[];
}

export const SignupField: FunctionComponent<SignupFieldProps> = (props) => {
    const {errorToMessage, validate, name, tabIndex, placeholder, type, icon, id, ariaLabel, validateFields} = props;
    return (
        <div className={`${styles.inputOnWhite} ${styles.signUpField}`}>
            <div className={styles.inputCont}>
                {icon && <div className={styles.inputIcon}><i className={icon}/></div>}
                <Field name={name} validateFields={validateFields}
                       validate={validate}>
                    {({meta, input}) => <>
                        <input {...input} placeholder={placeholder} type={type} tabIndex={tabIndex}
                               className={`${styles.input} ${meta.error && meta.touched ? styles.invalidInput : ''}`} id={id}
                               aria-label={ariaLabel}/>
                        {(meta.dirty || meta.submitFailed) && meta.error && !meta.active ?
                            <label className={styles.error}>
                                {errorToMessage(meta.error)}
                            </label> : null}
                    </>}
                </Field>
            </div>
        </div>
    );

};
